import { Redirect, Route } from 'react-router-dom';
import { IonRouterOutlet } from '@ionic/react';

import CompanyPage from '../../../pages/signinPage/companyPage/CompanyPage';
import { Wrapper } from './SignIn.styles';
import { RouteNames } from '../../../models/routes.model';

interface IComponentProps {}

const SignIn: React.FC<IComponentProps> = () => {
  return (
    <Wrapper>
      <IonRouterOutlet>
        <Route path={RouteNames.signin} exact render={() => <Redirect to={RouteNames.siCompany} />} />
        <Route path={RouteNames.siCompany} component={CompanyPage} />
        <Route render={() => <Redirect to={RouteNames.signin} />} />
      </IonRouterOutlet>
    </Wrapper>
  );
};

export default SignIn;
